export default "__VITE_ASSET__CE0$MQr3__"